import * as React from 'react';
const InfoIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M4.697 4.697a7.5 7.5 0 1 1 10.606 10.606A7.5 7.5 0 0 1 4.697 4.697M9.5 7.083a.5.5 0 0 1 .5-.5h.006a.5.5 0 0 1 .5.5v.007a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5zm.218 2.757a.1.1 0 0 0-.046.008l-.004.003-.032.015a.5.5 0 1 1-.439-.899l.03-.014a1.083 1.083 0 0 1 1.534 1.232l-.551 2.206a.083.083 0 0 0 .117.096l.028-.015a.5.5 0 0 1 .456.89l-.036.018a1.083 1.083 0 0 1-1.535-1.232l.55-2.205a.084.084 0 0 0-.072-.103"
      fill="currentColor"
    />
  </svg>
);
export default InfoIcon;
